<template>
  <div class="news-details">
    <div class="news-title">
      <!--<span>峰学资讯 > 资讯详情</span>-->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/news' }">峰学资讯</el-breadcrumb-item>
        <el-breadcrumb-item>资讯详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news-content" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="main-content">
        <div class="title-content">
          <div class="details-title">
            <h2>{{newsIdList.title}}</h2>
          </div>
          <div class="details-author">
            <span>{{ newsIdList.teacher_info ? newsIdList.teacher_info.name : newsIdList.author }}</span>
            <span class="split-line">|</span>
            <span class="data-info"> {{ newsIdList.add_time ? newsIdList.add_time.split(' ')[0] : '' }}</span>
            <span class="review-num" v-if="newsIdList.actual_watching_amount >= 0 && newsIdList.actual_watching_amount <= 9999">{{ newsIdList.actual_watching_amount }}人浏览</span>
            <span class="review-num" v-else-if="newsIdList.actual_watching_amount >= 10000 && newsIdList.actual_watching_amount <= 99999">{{ (newsIdList.actual_watching_amount / 10000).toFixed(1) }}万人浏览</span>
            <span class="review-num" v-else-if="newsIdList.actual_watching_amount === 100000">10万人浏览</span>
            <span class="review-num" v-else>10+万人浏览</span>
          </div>
        </div>
        <div class="details-content">
          <img :src="newsIdList.cover_url" alt v-if="isImg"/>
          <video v-else controls="controls" webkit-playsinline="" :poster="newsIdList.cover_url" playsinline="" :src="newsIdList.video_url" class="video"></video>
          <div class="article-content" v-html="newsIdList.content" v-if="isImg"></div>
          <div class="article-content" v-else>
            <p>{{newsIdList.summary}}</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import backTop from "@/assets/img/backTop.png";
export default {
  name: "NewsDetails",
  data() {
    return {
      pid: 0,
      newsIdList: {},
      isImg: true,
      fullscreenLoading: true,
      backTop:backTop
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.addView();
    this.loadData();
  },
  methods: {
    //加载资讯详情
    loadData() {
      this.$http({
        method: 'get',
        url: '/admin_api/v1/main_station/main/news/info/' + this.pid + '/',
        headers: {
          'AUTH-SYS': 'admin'
        },
      }).then(res => {
        if (res.data.code === 20000) {
          this.fullscreenLoading = false;
          this.newsIdList = res.data.data
          this.isImg = res.data.data.type === 1 ? true : false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    //点击增加浏览量
    addView(){
      this.$http({
        method: 'put',
        url: '/admin_api/v1/main_station/main/news/click/' + this.pid + '/',
        headers: {
          'AUTH-SYS': 'admin'
        },
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868791.otf');
}
.news-details {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin-top: 78px;
  background-color: #F5F7FA;
  .news-title{
    width: 1200px;
    margin: 0 auto;
    ::v-deep .el-breadcrumb__inner.is-link{
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
    span{
      display: inline-block;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      font-family: 'SourceHanSansCN Microsoft YaHei';
      font-weight: 400;
      color: #909295;
    }
  }
  .news-content {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 160px;
    .main-content{
      padding: 68px 48px;
      .title-content{
        width: 100%;
        border-bottom: 1px solid rgba(219,221,224,0.5);
        padding-bottom: 20px;
        .details-title{
          width: 100%;
          h2{
            font-size: 30px;
            font-family: 'SourceHanSansCNBold Microsoft YaHei';
            font-weight: bold;
            color: #0A0D0F;
            line-height: 45px;
          }
        }
        .details-author{
          width: 100%;
          display: flex;
          margin-top: 20px;
          justify-content: flex-start;
          span{
            font-size: 14px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: #434649;
            line-height: 21px;
          }
          .split-line{
            margin-left: 10px;
          }
          .data-info{
            margin-left: 10px;
          }
          .review-num{
            margin-left: 50px;
          }
        }
      }
      .details-content{
        width: 100%;
        padding: 48px 0;
        img{
          width: 100%;
          border-radius: 16px;
        }
        video{
          width: 100%;
          border-radius: 16px;
        }
        .article-content{
          width: 100%;
          margin: 30px 0;
          ::v-deep p{
            /*text-indent: 2em;*/
            font-size: 18px;
            font-family: 'SourceHanSansCN Microsoft YaHei';
            font-weight: 400;
            color: #0A0D0F;
            line-height: 32px;
            letter-spacing: 1px;
            margin-bottom: 30px;
            text-align: justify;
          }
          ::v-deep img{
           /* width: 100%;*/
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>